import React from "react";
import cn from "classnames";
import { Icon } from "assets/icons";

import styles from "./styles.module.scss";

/**
 * Аккордеон: parent — заголовок, children — раскрываемое содержимое.
 * - arrowZone: стрелка вынесена в отдельную кликабельную зону справа
 *   (клик по ней только сворачивает/разворачивает, не задевая parent)
 * - filled: заголовок с фиолетовой заливкой (блоки в модалках)
 */
export const Accordion = ({
  collapsed,
  parent,
  handleCollapse,
  className,
  childrenClassName,
  withIcon,
  arrowZone,
  filled,
  disabled,
  children,
}) => {
  const toggle = disabled ? undefined : handleCollapse;

  const arrow = (
    <Icon
      type="arrow"
      className={cn(styles.icon, collapsed ? "rotate-90" : "rotate-180")}
    />
  );

  return (
    <>
      <div
        className={cn(
          styles.header,
          {
            [styles.filled]: filled,
            [styles.disabled]: disabled,
          },
          className
        )}
        onClick={arrowZone ? undefined : toggle}
      >
        <div className={styles.parent}>{parent}</div>
        {withIcon &&
          (arrowZone ? (
            <div
              className={styles.arrowZone}
              onClick={(ev) => {
                ev.stopPropagation();
                toggle?.();
              }}
              onDoubleClick={(ev) => ev.stopPropagation()}
            >
              {arrow}
            </div>
          ) : (
            <div
              className={cn(styles.iconWrapper, filled && styles.iconStatic)}
            >
              {arrow}
            </div>
          ))}
      </div>
      <div
        className={cn(
          styles.accordion,
          { [styles.collapsed]: collapsed },
          childrenClassName
        )}
      >
        {children}
      </div>
    </>
  );
};
